import * as Types from '../../../../../../__generated__/schema';

import { CorrelationRule } from '../../../../../graphql/fragments/CorrelationRule.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCorrelationRuleVariables = Types.Exact<{
  input: Types.GetCorrelationRuleInput;
}>;

export type GetCorrelationRule = { correlationRule?: Types.Maybe<CorrelationRule> };

export type UpdateCorrelationRuleVariables = Types.Exact<{
  input: Types.PutCorrelationRuleInput;
}>;

export type UpdateCorrelationRule = { putCorrelationRule?: Types.Maybe<CorrelationRule> };

export type TestCorrelationRuleVariables = Types.Exact<{
  input: Types.TestCorrelationRuleInput;
}>;

export type TestCorrelationRule = {
  testCorrelationRule: {
    results?: Types.Maybe<
      Array<Pick<Types.TestCorrelationRuleYAMLTestResult, 'error' | 'name' | 'passed'>>
    >;
  };
};

export type CreatePullRequestForCorrelationRuleEditVariables = Types.Exact<{
  input: Types.CreatePullRequestForCorrelationRuleEditInput;
}>;

export type CreatePullRequestForCorrelationRuleEdit = {
  createPullRequestForCorrelationRuleEdit?: Types.Maybe<
    Pick<Types.CreatePullRequestResponse, 'url'>
  >;
};

export const GetCorrelationRuleDocument = gql`
  query GetCorrelationRule($input: GetCorrelationRuleInput!) {
    correlationRule(input: $input) {
      ...CorrelationRule
    }
  }
  ${CorrelationRule}
`;

/**
 * __useGetCorrelationRule__
 *
 * To run a query within a React component, call `useGetCorrelationRule` and pass it any options that fit your needs.
 * When your component renders, `useGetCorrelationRule` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorrelationRule({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCorrelationRule(
  baseOptions: Apollo.QueryHookOptions<GetCorrelationRule, GetCorrelationRuleVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCorrelationRule, GetCorrelationRuleVariables>(
    GetCorrelationRuleDocument,
    options,
  );
}
export function useGetCorrelationRuleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCorrelationRule, GetCorrelationRuleVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCorrelationRule, GetCorrelationRuleVariables>(
    GetCorrelationRuleDocument,
    options,
  );
}
export function useGetCorrelationRuleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetCorrelationRule, GetCorrelationRuleVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCorrelationRule, GetCorrelationRuleVariables>(
    GetCorrelationRuleDocument,
    options,
  );
}
export type GetCorrelationRuleHookResult = ReturnType<typeof useGetCorrelationRule>;
export type GetCorrelationRuleLazyQueryHookResult = ReturnType<
  typeof useGetCorrelationRuleLazyQuery
>;
export type GetCorrelationRuleSuspenseQueryHookResult = ReturnType<
  typeof useGetCorrelationRuleSuspenseQuery
>;
export type GetCorrelationRuleQueryResult = Apollo.QueryResult<
  GetCorrelationRule,
  GetCorrelationRuleVariables
>;
export const UpdateCorrelationRuleDocument = gql`
  mutation UpdateCorrelationRule($input: PutCorrelationRuleInput!) {
    putCorrelationRule(input: $input) {
      ...CorrelationRule
    }
  }
  ${CorrelationRule}
`;
export type UpdateCorrelationRuleMutationFn = Apollo.MutationFunction<
  UpdateCorrelationRule,
  UpdateCorrelationRuleVariables
>;

/**
 * __useUpdateCorrelationRule__
 *
 * To run a mutation, you first call `useUpdateCorrelationRule` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCorrelationRule` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCorrelationRule, { data, loading, error }] = useUpdateCorrelationRule({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCorrelationRule(
  baseOptions?: Apollo.MutationHookOptions<UpdateCorrelationRule, UpdateCorrelationRuleVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCorrelationRule, UpdateCorrelationRuleVariables>(
    UpdateCorrelationRuleDocument,
    options,
  );
}
export type UpdateCorrelationRuleHookResult = ReturnType<typeof useUpdateCorrelationRule>;
export type UpdateCorrelationRuleMutationResult = Apollo.MutationResult<UpdateCorrelationRule>;
export type UpdateCorrelationRuleMutationOptions = Apollo.BaseMutationOptions<
  UpdateCorrelationRule,
  UpdateCorrelationRuleVariables
>;
export const TestCorrelationRuleDocument = gql`
  mutation TestCorrelationRule($input: TestCorrelationRuleInput!) {
    testCorrelationRule(input: $input) {
      results {
        error
        name
        passed
      }
    }
  }
`;
export type TestCorrelationRuleMutationFn = Apollo.MutationFunction<
  TestCorrelationRule,
  TestCorrelationRuleVariables
>;

/**
 * __useTestCorrelationRule__
 *
 * To run a mutation, you first call `useTestCorrelationRule` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestCorrelationRule` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testCorrelationRule, { data, loading, error }] = useTestCorrelationRule({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestCorrelationRule(
  baseOptions?: Apollo.MutationHookOptions<TestCorrelationRule, TestCorrelationRuleVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TestCorrelationRule, TestCorrelationRuleVariables>(
    TestCorrelationRuleDocument,
    options,
  );
}
export type TestCorrelationRuleHookResult = ReturnType<typeof useTestCorrelationRule>;
export type TestCorrelationRuleMutationResult = Apollo.MutationResult<TestCorrelationRule>;
export type TestCorrelationRuleMutationOptions = Apollo.BaseMutationOptions<
  TestCorrelationRule,
  TestCorrelationRuleVariables
>;
export const CreatePullRequestForCorrelationRuleEditDocument = gql`
  mutation CreatePullRequestForCorrelationRuleEdit(
    $input: CreatePullRequestForCorrelationRuleEditInput!
  ) {
    createPullRequestForCorrelationRuleEdit(input: $input) {
      url
    }
  }
`;
export type CreatePullRequestForCorrelationRuleEditMutationFn = Apollo.MutationFunction<
  CreatePullRequestForCorrelationRuleEdit,
  CreatePullRequestForCorrelationRuleEditVariables
>;

/**
 * __useCreatePullRequestForCorrelationRuleEdit__
 *
 * To run a mutation, you first call `useCreatePullRequestForCorrelationRuleEdit` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePullRequestForCorrelationRuleEdit` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPullRequestForCorrelationRuleEdit, { data, loading, error }] = useCreatePullRequestForCorrelationRuleEdit({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePullRequestForCorrelationRuleEdit(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePullRequestForCorrelationRuleEdit,
    CreatePullRequestForCorrelationRuleEditVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePullRequestForCorrelationRuleEdit,
    CreatePullRequestForCorrelationRuleEditVariables
  >(CreatePullRequestForCorrelationRuleEditDocument, options);
}
export type CreatePullRequestForCorrelationRuleEditHookResult = ReturnType<
  typeof useCreatePullRequestForCorrelationRuleEdit
>;
export type CreatePullRequestForCorrelationRuleEditMutationResult =
  Apollo.MutationResult<CreatePullRequestForCorrelationRuleEdit>;
export type CreatePullRequestForCorrelationRuleEditMutationOptions = Apollo.BaseMutationOptions<
  CreatePullRequestForCorrelationRuleEdit,
  CreatePullRequestForCorrelationRuleEditVariables
>;
export function mockGetCorrelationRule({
  data,
  variables,
  errors,
}: {
  data: GetCorrelationRule;
  variables?: GetCorrelationRuleVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetCorrelationRuleDocument, variables },
    result: { data, errors },
  };
}
export function mockUpdateCorrelationRule({
  data,
  variables,
  errors,
}: {
  data: UpdateCorrelationRule;
  variables?: UpdateCorrelationRuleVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: UpdateCorrelationRuleDocument, variables },
    result: { data, errors },
  };
}
export function mockTestCorrelationRule({
  data,
  variables,
  errors,
}: {
  data: TestCorrelationRule;
  variables?: TestCorrelationRuleVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: TestCorrelationRuleDocument, variables },
    result: { data, errors },
  };
}
export function mockCreatePullRequestForCorrelationRuleEdit({
  data,
  variables,
  errors,
}: {
  data: CreatePullRequestForCorrelationRuleEdit;
  variables?: CreatePullRequestForCorrelationRuleEditVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: CreatePullRequestForCorrelationRuleEditDocument, variables },
    result: { data, errors },
  };
}
